import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { UserService } from '../services/user/user.service';
import { EntityService } from '../services/entity.service';
import { Location } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { AlertService } from '@coreservices/alert.service';
import { ServerSideRenderingService } from '@coreservices/server-side-rendering.service';
import { AuthService } from '@coreservices/auth.service';

@Injectable()
export class AccessGuard implements CanActivate {

  constructor(private _router: Router,
              private _userService: UserService,
              private _entityService: EntityService,
              private _alertService: AlertService,
              private _location: Location,
              private _ssr: ServerSideRenderingService,
              private _authService: AuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if(this._ssr.isBrowser) {
      return new Promise<boolean>(resolve => {
        if (state.url.indexOf('course_id') !== -1) {
          resolve(true);
          return;
        }

        // this._entityService.prolongate().subscribe(
        //   (success_response) => {
        //     this._userService.setClient(success_response);
        //     this._userService.setTrialPortalTime(success_response.portal.trial_end_time);
            if (window.location.search.substr(1).length > 0 && window.location.search.includes('hash')) {
              let multipleParams = window.location.search.substr(1).split('&');
              let hashParam: any = multipleParams[0].split('=');
              if (hashParam.length > 0 && hashParam[0] === 'hash') {
                if(!this._userService.refreshToken) {
                  this._authService?.tokenRefresh(hashParam[1]).subscribe(res => {
                    this._userService.setTokenPair({access_token: res.access_token, refresh_token: res.refresh_token}).subscribe(_ => {
                      setTimeout(() => {
                        this._entityService.get('auth/token/info').subscribe(
                          success_response => {

                            const portalObj = {
                              portal_member: success_response.portal_member,
                              portal: success_response.portal,
                              access_token: res.access_token,
                              refresh_token: res.refresh_token
                            }

                            let portalFields = portalObj.portal;
                            if(portalFields.custom_domain_enabled) {
                              portalFields.domain = portalFields.custom_domain;
                            } else {
                              portalFields.domain = portalFields.domain;
                            }
                            this._userService.setPortal(portalFields);
                            this._userService.setClient(portalObj.portal_member);
                            this._router.navigateByUrl('/admin');
                            resolve(true);
                          },
                        error => {
                          if(window.location.search.includes('lesson_public')) {
                            setTimeout(() => {
                              this._alertService.showError('unautorazed_lesson_access', 'lesson')
                            }, 500)
                          }
                          this._userService.deleteClient();
                          this._router.navigateByUrl('/login'+window.location.search);
                          resolve(false);
                        })
                      }, 200)
                    });
                  })
                } else {
                  this._entityService.get('auth/token/info').subscribe(
                    success_response => {

                      const portalObj = {
                        portal_member: success_response.portal_member,
                        portal: success_response.portal
                      }

                      let portalFields = portalObj.portal;
                      if(portalFields.custom_domain_enabled) {
                        portalFields.domain = portalFields.custom_domain;
                      } else {
                        portalFields.domain = portalFields.domain;
                      }
                      this._userService.setPortal(portalFields);
                      this._userService.setClient(portalObj.portal_member);
                      this._router.navigateByUrl('/admin');
                      resolve(true);
                    },
                  error => {
                    if(window.location.search.includes('lesson_public')) {
                      setTimeout(() => {
                        this._alertService.showError('unautorazed_lesson_access', 'lesson')
                      }, 500)
                    }
                    this._userService.deleteClient();
                    this._router.navigateByUrl('/login'+window.location.search);
                    resolve(false);
                  })
                }
              } else {
                resolve(false)
              }
              if (hashParam.length > 0 && hashParam[0] === 'hilfe') {
                localStorage.setItem('openIntercom', 'true');
                this._location.replaceState('/admin');
              }
            }
        if(this._userService.refreshToken) {
          resolve(true);
        } else {
          this._userService.deleteClient();
          this._router.navigateByUrl('/login'+window.location.search);
          resolve(false);
        }
        //   },
        //   error => {
        //     if(window.location.search.includes('lesson_public')) {
        //       setTimeout(() => {
        //         this._alertService.showError('unautorazed_lesson_access', 'lesson')
        //       }, 500)
        //     }
        //     this._userService.deleteClient();
        //     this._router.navigateByUrl('/login'+window.location.search);
        //     resolve(false);
        //   }
        // );
      });
    }
  }


}
